module.exports = __webpack_public_path__ + "static/media/icon5.673540d8.svg";